module.exports = __webpack_public_path__ + "media/JF-Cover-Video.d6e8a772.mp4";